import { env } from '@/app/env';
import { Environment } from '@/enums/system/enums';

/**
 * Utility function to check if reCAPTCHA is required based on the server environment.
 * Local, Development = False
 * Staging, Production = True
 *
 * NOTES: Staging and Production equal to Environment.Production
 *
 * @returns boolean - true if reCAPTCHA is required (i.e., in Production), false otherwise
 */
export const checkIfRecaptchaRequired = (): boolean => {
  return env.NEXT_PUBLIC_SERVER_ENVIRONMENT === Environment.Production;
};
